import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = []

    connect() {
        this.currentContractCode = ''
        this.currentContractTitle = ''
        this.modal = document.getElementById('waitingListModal')
        this.form = document.getElementById('waitingListForm')
        this.visitorsContainer = document.getElementById('visitorsContainer')
        
        this.initializeEventListeners()
    }

    initializeEventListeners() {
        if (!this.modal || !this.form) return

        this.form.addEventListener('submit', (e) => this.submitWaitingList(e))
        
        window.addEventListener('click', (event) => {
            if (event.target === this.modal) {
                this.closeModal()
            }
        })
    }

    openModal(code, title) {
        this.currentContractCode = code
        this.currentContractTitle = title
        this.modal.style.display = 'block'
        document.body.style.overflow = 'hidden'
    }

    closeModal() {
        this.modal.style.display = 'none'
        document.body.style.overflow = 'auto'
        this.form.reset()
    }

    addVisitor() {
        const visitorCount = this.visitorsContainer.children.length + 1
        
        const visitorEntry = document.createElement('div')
        visitorEntry.className = 'visitor-entry'
        visitorEntry.innerHTML = `
            <div class="form-group">
                <label for="visitor_name_${visitorCount}">Lankytojo vardas *</label>
                <input type="text" id="visitor_name_${visitorCount}" name="visitor_name[]" required>
            </div>
            <div class="form-group">
                <label for="visitor_surname_${visitorCount}">Lankytojo pavardė *</label>
                <input type="text" id="visitor_surname_${visitorCount}" name="visitor_surname[]" required>
            </div>
            <div class="form-group">
                <label for="visitor_birth_${visitorCount}">Lankytojo gimimo diena *</label>
                <input type="date" id="visitor_birth_${visitorCount}" name="visitor_birth[]" required>
            </div>
            <button type="button" class="btn btn-danger" onclick="this.parentElement.remove()">Pašalinti</button>
        `
        
        this.visitorsContainer.appendChild(visitorEntry)
    }

    submitWaitingList(event) {
        event.preventDefault()
        
        const formData = new FormData(event.target)
        const data = {
            contract_code: this.currentContractCode,
            contract_title: this.currentContractTitle,
            email: formData.get('email'),
            phone: formData.get('phone'),
            visitors: []
        }
        
        const visitorNames = formData.getAll('visitor_name[]')
        const visitorSurnames = formData.getAll('visitor_surname[]')
        const visitorBirths = formData.getAll('visitor_birth[]')
        
        for (let i = 0; i < visitorNames.length; i++) {
            if (visitorNames[i] && visitorSurnames[i] && visitorBirths[i]) {
                data.visitors.push({
                    name: visitorNames[i],
                    surname: visitorSurnames[i],
                    birth: visitorBirths[i]
                })
            }
        }
        
        let waitingList = JSON.parse(localStorage.getItem('waitingList') || '[]')
        waitingList.push(data)
        localStorage.setItem('waitingList', JSON.stringify(waitingList))
        
        alert('Sėkmingai užsiregistruota į eilę: ' + this.currentContractTitle)
        this.closeModal()
    }

    disconnect() {
        document.body.style.overflow = 'auto'
    }
}

